import React, { ReactNode, useEffect, useMemo, useState } from 'react';
import { Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import FilterIcon from 'src/assets/icons/filterIcon';

import { ITableFilters } from '@interfaces';
import _ from 'lodash';
import FilterModal from './filterModal';
import SelectedFilters from './selectedFilters';
import { filterBarkeys } from '../types';

interface FilterBarProps {
    showSearch?: boolean;
    showFilterButton?: boolean;
    showAddButton?: boolean;
    leadModalVisible: boolean;
    filtarsValues?: ITableFilters;
    setLeadModalVisible: (value: boolean) => void;
    onSearch?: (value: string) => void;
    onFilterClick?: () => void;
    onRemoveFilter?: (filter: string) => void;
    refetchWithFilters?: (filters: ITableFilters) => void;
    AddButton?: ReactNode;
    filtersToShow: filterBarkeys[];
}

const FilterBar: React.FC<FilterBarProps> = ({
    showSearch = true,
    showFilterButton = true,
    showAddButton = true,
    onSearch,
    setLeadModalVisible,
    leadModalVisible,
    refetchWithFilters,
    filtarsValues,
    AddButton,
    filtersToShow,
}) => {
    const [filterModalVisible, setFilterModalVisible] = useState<boolean>(false);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState<ITableFilters>({
        agent: [],
        status: [],
        city: [],
        segment: [],
        productType: [],
        channel: [],
        quantity: null,
        brand: [],
        createdAt: null,
        searchedText: '',
        province: [],
        customerStatus: [],
    });

    useEffect(() => {
        if (filtarsValues) {
            setFilters(filtarsValues);
            setSearch(filtarsValues.searchedText);
        }
    }, [filtarsValues]);

    const onCloseHandler = () => {
        setLeadModalVisible(false);
        setFilterModalVisible(false);
    };

    const handleAddFilterClick = () => {
        setFilterModalVisible(true);
    };

    const debouncedRefetch = useMemo(() => {
        return _.debounce(filters => {
            if (refetchWithFilters) refetchWithFilters(filters);
        }, 500);
    }, [refetchWithFilters]);

    return (
        <div className="p-3">
            <div className="flex items-center bg-white w-full">
                <div className="flex w-[80%] flex-row flex-nowrap items-center">
                    {showSearch && (
                        <Input
                            className="max-w-[500px] h-[40px] border border-[#DBD7D7] hover:!border-[#DBD7D7] focus:!border-[#DBD7D7] shadow-none"
                            placeholder="Search via name, id, cnic, email"
                            prefix={<SearchOutlined />}
                            value={search}
                            onChange={e => {
                                const updatedFilters = { ...filters };
                                updatedFilters.searchedText = e.target.value;
                                setSearch(updatedFilters.searchedText);
                                if (onSearch) onSearch(updatedFilters.searchedText);
                                debouncedRefetch(updatedFilters);
                            }}
                        />
                    )}

                    {showFilterButton && !leadModalVisible && (
                        <Button type="link" className="text-blue-500 flex items-center whitespace-nowrap" icon={<FilterIcon />} onClick={handleAddFilterClick}>
                            Add Filter
                        </Button>
                    )}
                </div>
                <div className="w-[20%] flex justify-end">{showAddButton && AddButton}</div>
            </div>
            {/* Selected Filters */}
            <div className="flex flex-wrap gap-2">
                <SelectedFilters
                    values={filters}
                    setvalues={values => {
                        setFilters(values);
                        if (refetchWithFilters) refetchWithFilters(values);
                    }}
                />
            </div>

            <FilterModal
                values={filters}
                setvalues={values => {
                    setFilters(values);
                    if (refetchWithFilters) refetchWithFilters(values);
                }}
                visible={filterModalVisible}
                onClose={onCloseHandler}
                filtersToShow={filtersToShow}
            />
        </div>
    );
};

export default FilterBar;
